import { FC, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

type CheckInstallationMessageProps = {
  classNames?: string;
  asListItem?: boolean;
} & PropsWithChildren;

export const CheckInstallationMessage: FC<CheckInstallationMessageProps> = ({ children, asListItem, classNames }) => {
  const Element = asListItem ? 'li' : 'p';
  return <Element className={twMerge('text-sm font-normal leading-5 text-gray-600', classNames)}>{children}</Element>;
};
